import { client, flattenItem, flattenItems } from '../services/contentful';
import isPublished from '../utils/isPublished';
import { fetchTopics } from '../services/topics';
import {
  SET_CURRENT_TOPIC_SUCCESS,
  RESET_CURRENT_TOPIC,
  SET_COURSE_TOPICS
} from './types';

export const setCurrentTopic = (topicId) => {
  return (dispatch) => {
    return client
      .getEntry(topicId)
      .then((response) => {
        const currentTopic = isPublished(response) && flattenItem(response);
        const data = {
          type: SET_CURRENT_TOPIC_SUCCESS,
          currentTopic
        };

        const { sections } = currentTopic;

        if (sections && sections.length > 0) {
          data.currentTopic = {
            ...currentTopic,
            sections: flattenItems(sections)
          };
        }

        dispatch(data);
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

export const getTopics = ({ classId, topicIds }) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      fetchTopics({ classId, topicIds })
        .then(({ list, count }) => {
          dispatch({
            type: SET_COURSE_TOPICS,
            list,
            count
          });

          resolve(list);
        })
        .catch((error) => {
          reject(error);
          console.error(`getTopics: ${error}`);
        });
    });
  };
};

export const resetCurrentTopic = () => {
  return (dispatch) => {
    dispatch({ type: RESET_CURRENT_TOPIC });
  };
};
